<div class="slider-inner-container">
    <app-slider id="slider" class="slider-element swiper_wrapper include-header"></app-slider>
    
    <!-- <ng-container *ngIf="marquees$ as rows">
        <ng-container *ngIf="rows.length >= 1">
            <div class="announcement-container">
                <div class="marquee-container">
                    <div class="container">
                        <div class="position-relative vertical-center">
                            <span [innerHTML]="svg.megaphoneIcon | safeHtml"></span>
                            <ng-marquee [stopOnHover]="true" [duration]="(rows.length*40) + 's'">
                                <ng-container *ngFor="let item of rows">
                                    <ng-container *ngFor="let content of item.contents">
                                        <mark  class="marquee-color">
                                            {{ content['content'] }}<div style="width: 800px; display: inline-block"></div>
                                        </mark>
                                    </ng-container>
                                </ng-container>
                            </ng-marquee>
                            <label [class]="'font-weight-bold read-more ' + 'read-more-' + projectCode" (click)="onReadMoreMarquee()">{{ 'Read More' | translate }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container> -->
    <ng-container *ngIf="combinedMarquee?.length">
  <div class="announcement-container">
    <div class="marquee-container">
      <div class="container">
        <div class="position-relative vertical-center">
          <span [innerHTML]="svg.megaphoneIcon | safeHtml"></span>
          <ng-marquee #marqueeElement
            [stopOnHover]="true"
            [duration]="marqueeDuration">
            <ng-container *ngFor="let text of combinedMarquee">
              <mark #marqueeItem class="marquee-color">
                {{ text }}
                <span class="marquee-gap"></span>
              </mark>
            </ng-container>
          </ng-marquee>

          <label
            class="font-weight-bold read-more"
            [ngClass]="'read-more-' + projectCode"
            (click)="onReadMoreMarquee()">
            {{ 'Read More' | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</ng-container>

</div>

<!-- Step -->
<!-- <section class="step-container">
    <div class="container">
        <div class="row horizontal-center">
            <div class="step-box">
                <div class="step-1 row">
                    <div class="col-5 offset-md-4 offset-lg-4 p-l-0">
                        <p class="ml-1">{{'OPEN AN ACCOUNT' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="step-box">
                <div class="step-2 row">
                    <div class="col-5 offset-md-4 offset-lg-4 p-l-0">
                        <p class="ml-3">{{'DEPOSIT FUND' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="step-box">
                <div class="step-3 row">
                    <div class="col-5 offset-md-4 offset-lg-4 p-l-0">
                        <p class="ml-3">{{'PLAY AND WIN' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- Step -->
<section class="step-container" *ngIf="!(isLoggedIn$ | async)">
    <div class="container">
        <div class="row horizontal-center">
            <div class="col-4 m-l-10">
                <img src="assets/images/step-1.png">
                <p>{{'OPEN AN ACCOUNT' | translate}}</p>
            </div>
            <div class="col-4">
                <img src="assets/images/step-2.png">
                <p>{{'DEPOSIT FUND' | translate}}</p>
            </div>
            <div class="col-4">
                <img src="assets/images/step-3.png">
                <p>{{'PLAY AND WIN' | translate}}</p>
            </div>
            <!-- <div class="step-box">
                <div class="step-1 row">
                    <div class="col-5 offset-md-4 offset-lg-4 p-l-0">
                        <p class="ml-1">{{'OPEN AN ACCOUNT' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="step-box">
                <div class="step-2 row">
                    <div class="col-5 offset-md-4 offset-lg-4 p-l-0">
                        <p class="ml-3">{{'DEPOSIT FUND' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="step-box">
                <div class="step-3 row">
                    <div class="col-5 offset-md-4 offset-lg-4 p-l-0">
                        <p class="ml-3">{{'PLAY AND WIN' | translate}}</p>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</section>

<section id="content">
    <!-- ambassador -->
    <div class="container m-t-50">
        <!-- IBC22 -->
        <!-- <div class="ambassador-banner" *ngIf="sitePrefix == 'i22'">
            <div class="container">
                <div class="row vertical-center">
                    <div class="col-12 m-t-25">
                        <div class="row vertical-center">
                            <div class="col-9 margin-content">
                                <p class="ambassador-title-1">{{ "WELCOME TO "+siteName | translate | uppercase }}</p>
                                <p class="ambassador-title-2">{{ "WIN BIG WITH US!" | translate | uppercase }}</p>
                                <p class="ambassador-title-3">{{ "GO BIG WIN BIG" | translate | uppercase }}</p>
                                <p class="ambassador-title-4 m-t-15">{{ "PROGRESSIVE JACKPOT" | translate | uppercase }}</p>
                                <div class="ambassador-box">
                                    <p class="amount">{{currency}}
                                    <ng2-odometer [number]="jackpotAmount" [config]="odometerConfig"></ng2-odometer></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- Slider -->
        <div class="content-wrap p-0 m-0" *ngIf="isGameCategoryProivdersFetched && (sitePrefix == 'i22' || sitePrefix == 'k3'  || sitePrefix == 's66' || projectCode == 'qp2c' || projectCode == 'qply')">
            <div class="container">
              <app-jackpot-slider id="jackpot-slider" class="slider-element swiper_wrapper"></app-jackpot-slider>
            </div>
        </div>

        <!--  -->
        <div class="ambassador-banner align-content" *ngIf="sitePrefix == 'w7'">
            <div class="container">
                <div class="row vertical-center">
                    <div class="col-12 m-t-25">
                        <div class="row vertical-center">
                            <div class="col-9 margin-content k3-ambassador">
                                <p class="ambassador-title-1">{{ "WELCOME TO "+siteName | translate | uppercase }}</p>
                                <p class="ambassador-title-2">{{ "WIN BIG WITH US!" | translate }}</p>
                                <p class="ambassador-title-3">{{ "GO BIG WIN BIG" | translate }}</p>
                                <p class="ambassador-title-4 m-t-25">{{ "PROGRESSIVE JACKPOT" | translate | uppercase }}</p>
                                <div class="ambassador-box">
                                    <p class="amount">{{currency}}
                                    <app-client-odometer [number]="jackpotAmount" [config]="odometerConfig"></app-client-odometer></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ACE66 -->
        <!-- <div class="ambassador-banner" *ngIf="projectCode == 'qp2c'">
            <div class="container">
                <div class="row vertical-center">
                    <div class="col-12 m-t-25">
                        <div class="row vertical-center">
                            <div class="col-9 margin-content">
                                <p class="ambassador-title-1">{{ "WELCOME TO "+siteName | translate | uppercase }}</p>
                                <p class="ambassador-title-2">{{ "WIN BIG WITH US!" | translate | uppercase }}</p>
                                <p class="ambassador-title-3">{{ "ACE YOUR GAME" | translate | uppercase }}</p>
                                <p class="ambassador-title-4 m-t-15">{{ "PROGRESSIVE JACKPOT" | translate | uppercase }}</p>
                                <div class="ambassador-box">
                                    <p class="amount">{{currency}}
                                    <ng2-odometer [number]="jackpotAmount" [config]="odometerConfig"></ng2-odometer></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        
        <!-- QP6 / QP8 -->
        <div class="ambassador-banner" *ngIf="sitePrefix == 'mcb' || sitePrefix == 'qp10' || sitePrefix == 'qpci01' || sitePrefix == 'qp11'">
            <div class="container">
                <div class="row vertical-center">
                    <div class="col-12 m-t-25">
                        <div class="row vertical-center">
                            <div class="col-9 margin-content">
                                <p class="ambassador-title-1">{{ 'WELCOME TO [site_prefix]' | translate : { site_prefix : siteName } }}</p>
                                <p class="ambassador-title-2" [ngStyle]="{'padding-top': language === 'BN'? '10px': ''}">{{ "WIN BIG WITH US !" | translate | uppercase }}</p>
                                <p class="ambassador-title-3" [ngStyle]="{'padding-top': language === 'BN'? '10px': ''}">{{ "GO BIG WIN BIG" | translate | uppercase }}</p>
                                <p class="ambassador-title-4 m-t-25">{{ "PROGRESSIVE JACKPOT" | translate | uppercase }}</p>
                                <div class="ambassador-box">
                                    <p class="amount">{{currency}}
                                    <app-client-odometer [number]="jackpotAmount" [config]="odometerConfig"></app-client-odometer></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- QP14 -->
        <div class="ambassador-banner" *ngIf="projectCode == 'qp14'">
            
        </div>

        <!-- QP16 -->
        <div class="ambassador-banner" *ngIf="sitePrefix == 'lb'">
            <div class="container">
                <div class="row vertical-center">
                    <div class="col-12 m-t-25">
                        <div class="row vertical-center">
                            <div class="col-9 margin-content">
                                <p class="ambassador-title-1">{{ "WELCOME "+siteName | translate | uppercase }}</p>
                                <p class="ambassador-title-2">{{ "Ambassadors" | translate | uppercase }}</p>
                                <p class="ambassador-title-3">{{ "GO BIG WIN BIG" | translate | uppercase }}</p>
                                <p class="ambassador-title-4 m-t-15">{{ "PROGRESSIVE JACKPOT" | translate | uppercase }}</p>
                                <div class="ambassador-box">
                                    <p class="amount">{{currency}}
                                    <app-client-odometer [number]="jackpotAmount" [config]="odometerConfig"></app-client-odometer></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

        <!-- <div class="jackpot" *ngIf="sitePrefix == 'mcb'">
            <p class="ambassador-title ml-4 text-left" id="ambassador-title-1">{{ 'WELCOME TO [site_prefix]' | translate : { site_prefix : siteName } }}</p>
            <p class="ambassador-title ml-4 text-left" id="ambassador-title-2">{{ "WIN BIG WITH US !" | translate | uppercase}}</p>
            <p class="ambassador-title ml-4 text-left" id="ambassador-title-3">{{ "GO BIG WIN BIG" | translate | uppercase }}</p>
            <img src="/assets/images/{{projectCode}}-up-ambassador.jpg">
            <p class="ambassador-title ml-4 text-left" id="ambassador-title-4">{{ "PROGRESSIVE JACKPOT" | translate | uppercase }}</p>
            <img class="ambassador-box ml-4 text-left" src="/assets/images/{{projectCode}}-up-ambassador-box.png">
            <div class="amount ml-4 text-left">
                <p>{{currency}}</p>
                <ng2-odometer [number]="number" [config]="odometerConfig" [observable]="observable"></ng2-odometer>
            </div>
        </div> -->

        <!-- <div class="jackpot" *ngIf="sitePrefix == 'la'">
            <p class="ambassador-title ml-4 text-left" id="ambassador-title-1">{{ "WELCOME "+siteName | translate | uppercase}}</p>
            <p class="ambassador-title ml-4 text-left" id="ambassador-title-2">{{ "WIN BIG WITH US !" | translate | uppercase}}</p>
            <p class="ambassador-title ml-4 text-left" id="ambassador-title-3">{{ "GO BIG WIN BIG" | translate | uppercase }}</p>
            <img src="/assets/images/{{sitePrefix}}-up-ambassador.jpg">
            <p class="ambassador-title ml-4 text-left" id="ambassador-title-4">{{ "PROGRESSIVE JACKPOT" | translate | uppercase }}</p>
            <img class="ambassador-box ml-4 text-left" src="/assets/images/{{sitePrefix}}-up-ambassador-box.png">
            <div class="amount ml-4 text-left">
                <p>{{currency}}</p>
                <ng2-odometer [number]="number" [config]="odometerConfig" [observable]="observable"></ng2-odometer>
            </div>
        </div>         -->

    <!-- Category -->
    <div class="section gamelist-tabs">
        <div class="container container-shadow">
          <div class="row vendor-tabs">
            <ng-container *ngIf="category_locales">       
              <div class="col-12 p-0" *ngIf="category_locales">
                  <app-game-menu [gameCategoriesList]="category_locales" [gameCategoryCode]="activeGameCategoryCode" [gameCategoryName]="activeGameCategoryName"></app-game-menu>
              </div>
            </ng-container>
          </div>
  
          <div class="stack-order">
            <!-- Game Provider -->
            <div class="row active-tab-bg vertical-center" [class]="'row active-tab-bg vertical-center ' + 'active-tab-' + activeGameCategoryCode" [ngStyle]="{'height': sitePrefix === 'mcb'? '360px': ''}">
                <div class="col-5">
                    <div class="row m-l-0 m-r-0 p-l-5 p-r-5 p-b-15 vendor-container">
                        <ng-container>
                            <ng-container *ngIf="categoryGames?.length > 0 && !isSkeletonCategoryLocales; else skeletonGameCategoryDesc">
                                <div class="col-12">
                                    <div *ngIf="category_locales == null" class="text-center">
                                        <span class="spinner-border spinner-border-sm mm-t-5" aria-hidden="true"></span>
                                    </div>
                                    <div *ngIf="activeGameCategoryCode">
                                        <h3 class="category-title">{{ category_locales[activeGameCategoryCode]['title'] == 'Crickets' ? (category_locales[activeGameCategoryCode]['title'] | translate) : category_locales[activeGameCategoryCode]['title'] }}</h3>
                                        <p class="category-description">{{ category_locales[activeGameCategoryCode]['description'] == 'Stay one click away from crickets bettings with [site_prefix]. You are privileged to enjoy wide options of live bettings with multiple bonuses. Track your bets in real time!' ? (category_locales[activeGameCategoryCode]['description'] | translate : { 'site_prefix' : siteName }) : category_locales[activeGameCategoryCode]['description'] }}</p>
                                    </div>
                                    <!-- <div *ngIf="activeGameCategoryCode === 'LC'">
                                        <h3 class="category-title">{{'Casino' | translate | uppercase}} {{ category_locales[activeGameCategoryCode]['title'] }}</h3>
                                        <p class="category-description">{{ 'Get in touch with live dealers for Roulette, Blackjack, Baccarat and more at your fingertips with [site_prefix] from the comfort of your home, even better than physical casino!' | translate:{'site_prefix': siteName} }}</p>
                                    </div>
                                    <div *ngIf="activeGameCategoryCode === 'SL'">
                                        <h3 class="category-title">{{'Slots' | translate | uppercase}}</h3>
                                        <p class="category-description">{{ 'Drop your button to spin along with the exciting jingling. Build your fortune by winning a pile of cash in [site_prefix]. Shuffle your luck now!' | translate:{'site_prefix': siteName} }}</p>
                                    </div>
                                    <div *ngIf="activeGameCategoryCode === 'FS'">
                                        <h3 class="category-title">{{'Fishing' | translate | uppercase}}</h3>
                                        <p class="category-description">{{ 'Experience one of the best classic games you should never miss in [site_prefix]. Aim the right targets and shoot all you can. The ocean is yours!' | translate:{'site_prefix': siteName} }}</p>
                                    </div>
                                    <div *ngIf="activeGameCategoryCode === 'SP'">
                                        <h3 class="category-title">{{'Sports' | translate | uppercase}}</h3>
                                        <p class="category-description">{{ 'Stay one click away from sports bettings with [site_prefix]. You are privileged to enjoy wide options of live bettings with multiple bonuses on soccer, football, baseball, tennis, basketball, esports and more. Track your bets in real time!' | translate:{'site_prefix': siteName} }}</p>
                                    </div>
                                    <div *ngIf="activeGameCategoryCode === 'ES'">
                                        <h3 class="category-title">{{'Esports' | translate | uppercase}}</h3>
                                        <p class="category-description">{{ 'Stay one click away from sports bettings with [site_prefix]. You are privileged to enjoy wide options of live bettings with multiple bonuses on soccer, football, baseball, tennis, basketball, esports and more. Track your bets in real time!' | translate:{'site_prefix': siteName} }}</p>
                                    </div>
                                    <div *ngIf="activeGameCategoryCode === 'CF'">
                                        <h3 class="category-title">{{'Cock Fighting' | translate | uppercase}}</h3>
                                        <p class="category-description">{{ 'Online Cockfighting is a popular online game in the world, defined as a brutal fight between male chickens (roosters), in which people make a bet on the result of the fight.' | translate }}</p>
                                    </div>
                                    <div *ngIf="activeGameCategoryCode === 'CR'">
                                        <h3 class="category-title">{{'Crickets' | translate | uppercase}}</h3>
                                        <p class="category-description">{{ 'Stay one click away from sports bettings with [site_prefix]. You are privileged to enjoy wide options of live bettings with multiple bonuses on soccer, football, baseball, tennis, basketball, esports and more. Track your bets in real time!' | translate:{'site_prefix': siteName} }}</p>
                                    </div>
                                    <div *ngIf="activeGameCategoryCode === 'LT'">
                                        <h3 class="category-title">{{'Lottery' | translate | uppercase}}</h3>
                                        <p class="category-description">{{ 'Stay one click away from sports bettings with [site_prefix]. You are privileged to enjoy wide options of live bettings with multiple bonuses on soccer, football, baseball, tennis, basketball, esports and more. Track your bets in real time!' | translate:{'site_prefix': siteName} }}</p>
                                    </div> -->
                                    <!-- </div>
                                    <div *ngIf="activeGameCategoryCode === 'CG'">
                                        <h3 class="category-title">{{'Crash Game' | translate | uppercase}}</h3>
                                        <p class="category-description">{{ 'Crash is a simple game of chance where the player picks the cashout amount for a betting round as an icon representing a rocket flies through a grid.' | translate }}</p>
                                    </div>
                                    <div *ngIf="activeGameCategoryCode === 'TB'">
                                        <h3 class="category-title">{{'Table' | translate | uppercase}}</h3>
                                        <p class="category-description">{{ 'A fully automated table game that allows you to place your bets via a touch screen on your individual layout.' | translate }}</p>
                                    </div> -->
                                </div>
                            </ng-container>
            
                            <!-- Skeleton Loading -->
                            <ng-template #skeletonGameCategoryDesc>
                                <ng-container *ngIf="isSkeletonCategoryLocales">
                                    <div class="col-11 p-10">
                                        <div>
                                            <h3 class="skeleton skeleton-game-menu-title ml-0 mb-3 w-50"></h3>
                                            <p class="skeleton skeleton-text m-0 w-75"></p>
                                            <p class="skeleton skeleton-text w-75"></p>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-template>
            
                            <ng-container *ngIf="categoryGames?.length > 0 && !isSkeletonCategoryLocales; else skeletonCategoryGames">
                                <div class="col-2 p-l-10 p-r-10 p-b-20" *ngFor="let item of categoryGames | slice: 0:10; let i = index">
                                    <img [src]="checkImg(item, 2, false)" [class]="'provider-icon'" (click)="onRedirect(item, activeGameCategoryCode)">
            
                                    <!-- <div class="ribbon-wrapper-green" *ngIf="+item.vpn === 1">
                                        <div class="vpn-ribbon">{{ 'VPN' | translate }}</div>
                                        </div>
                                        <div class="ribbon-wrapper-green" *ngIf="item.type === 'APP'">
                                            <div class="ribbon-green">{{ item.type }}</div>
                                        </div> -->
                                    <!-- <app-favorite-game currentPage="home" [gameProviderId]="item.game_provider_id" [categoryCode]="activeGameCategoryCode" [isFavorite]="item.favorite"></app-favorite-game> -->
                                </div>
                            </ng-container>
            
            
                            <!-- Skeleton Loading -->
                            <ng-template #skeletonCategoryGames>
                                <ng-container *ngIf="isSkeletonCategoryLocales">
                                    <div class="col-2 p-l-10 p-r-10" *ngFor="let item of [].constructor(10); let i = index">
                                        <p [class]="'provider-icon skeleton skeleton-provider-icon'">
                                    </div>
                                </ng-container>
                            </ng-template>
                            <div *ngIf="activeGameCategoryCode === 'LC'">
                                <a *ngIf="categories?.LC.length > 10" routerLink="/casino">{{ 'More Games' | translate }} ></a>
                            </div>
                            <div *ngIf="activeGameCategoryCode === 'SL'">
                                <a *ngIf="categories?.SL.length > 10" routerLink="/slots">{{ 'More Games' | translate }} ></a>
                            </div>
                            <div *ngIf="activeGameCategoryCode === 'FS'">
                                <a *ngIf="categories?.FS.length > 10" routerLink="/fishing">{{ 'More Games' | translate }} ></a>
                            </div>
                            <div *ngIf="activeGameCategoryCode === 'SP'">
                                <a *ngIf="categories?.SP.length > 10" routerLink="/sports">{{ 'More Games' | translate }} ></a>
                            </div>
                            <div *ngIf="activeGameCategoryCode === 'ES'">
                                <a *ngIf="categories?.ES.length > 10" routerLink="/esports">{{ 'More Games' | translate }} ></a>
                            </div>
                            <div *ngIf="activeGameCategoryCode === 'CF'">
                                <a *ngIf="categories?.CF.length > 10" routerLink="/cock-fighting">{{ 'More Games' | translate }} ></a>
                            </div>
                            <div *ngIf="activeGameCategoryCode === 'CK'">
                                <a *ngIf="categories?.CK.length > 10" routerLink="/crickets">{{ 'More Games' | translate }} ></a>
                            </div>
                            <div *ngIf="activeGameCategoryCode === 'LT'">
                                <a *ngIf="categories?.LT.length > 10" routerLink="/lottery">{{ 'More Games' | translate }} ></a>
                            </div>
                            <div *ngIf="activeGameCategoryCode === 'CG'">
                                <a *ngIf="categories?.CG.length > 10" routerLink="/crash-game">{{ 'More Games' | translate }} ></a>
                            </div>
                        </ng-container>

                        <!-- Skeleton Loading -->
                        <!-- <ng-template #skeletonGameCategoryDesc>
                            <ng-container *ngIf="isSkeletonCategoryLocales">
                                <div class="col-11 p-10">
                                    <div>
                                        <h3 class="skeleton skeleton-game-menu-title ml-0 mb-3 w-50"></h3>
                                        <p class="skeleton skeleton-text m-0 w-75"></p>
                                        <p class="skeleton skeleton-text w-75"></p>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-template>

                      <ng-container *ngIf="categoryGames.length > 0 && !isSkeletonCategoryLocales; else skeletonCategoryGames">
                        <div class="col-2 p-l-10 p-r-10 p-b-20" *ngFor="let item of categoryGames | slice: 0:10; let i = index">
                                <img [src]="checkImg(item, 2, false)" [class]="'provider-icon'" (click)="onRedirect(item, activeGameCategoryCode)"> -->
                                
                                <!-- <div class="ribbon-wrapper-green" *ngIf="+item.vpn === 1">
                                <div class="vpn-ribbon">{{ 'VPN' | translate }}</div>
                                </div>
                                <div class="ribbon-wrapper-green" *ngIf="item.type === 'APP'">
                                    <div class="ribbon-green">{{ item.type }}</div>
                                </div> -->
                            <!-- <app-favorite-game currentPage="home" [gameProviderId]="item.game_provider_id" [categoryCode]="activeGameCategoryCode" [isFavorite]="item.favorite"></app-favorite-game> -->
                        <!-- </div>
                      </ng-container> -->

                      <!-- Skeleton Loading -->
                      <!-- <ng-template #skeletonCategoryGames>
                        <ng-container *ngIf="isSkeletonCategoryLocales">
                            <div class="col-2 p-l-10 p-r-10" *ngFor="let item of [].constructor(10); let i = index">
                                <p [class]="'provider-icon skeleton skeleton-provider-icon'">
                            </div>
                        </ng-container>
                      </ng-template>
                      
                      <div *ngIf="activeGameCategoryCode === 'LC'">
                        <a *ngIf="categories?.LC.length > 10" routerLink="/casino">{{ 'More Games' | translate }} ></a>
                      </div>
                      <div *ngIf="activeGameCategoryCode === 'SL'">
                        <a *ngIf="categories?.SL.length > 10" routerLink="/slots">{{ 'More Games' | translate }} ></a>
                      </div>
                      <div *ngIf="activeGameCategoryCode === 'FS'">
                        <a *ngIf="categories?.FS.length > 10" routerLink="/fishing">{{ 'More Games' | translate }} ></a>
                      </div>
                      <div *ngIf="activeGameCategoryCode === 'SP'">
                        <a *ngIf="categories?.SP.length > 10" routerLink="/sports">{{ 'More Games' | translate }} ></a>
                      </div>
                      <div *ngIf="activeGameCategoryCode === 'ES'">
                        <a *ngIf="categories?.ES.length > 10" routerLink="/esports">{{ 'More Games' | translate }} ></a>
                      </div>
                      <div *ngIf="activeGameCategoryCode === 'CF'">
                        <a *ngIf="categories?.CF.length > 10" routerLink="/cock-fighting">{{ 'More Games' | translate }} ></a>
                      </div>
                      <div *ngIf="activeGameCategoryCode === 'CR'">
                        <a *ngIf="categories?.CR.length > 10" routerLink="/crickets">{{ 'More Games' | translate }} ></a>
                      </div>
                      <div *ngIf="activeGameCategoryCode === 'LT'">
                        <a *ngIf="categories?.LT.length > 10" routerLink="/lottery">{{ 'More Games' | translate }} ></a>
                      </div>
                      <div *ngIf="activeGameCategoryCode === 'CG'">
                        <a *ngIf="categories?.CG.length > 10" routerLink="/crash-game">{{ 'More Games' | translate }} ></a>
                      </div>
                      <div *ngIf="activeGameCategoryCode === 'TB'">
                        <a *ngIf="categories?.TB.length > 10" routerLink="/table">{{ 'More Games' | translate }} ></a>
                      </div> -->
                  </div>
                </div>
            </div>
          </div>
        </div>
    </div>

    <!-- Hot Games -->
    <div class="container m-b-60">
        <ng-container *ngIf="gameStack.length > 0 && !isSkeletonHotGames; else skeletonHotGames">
            <h1 class="section-title float-left">{{'Hot Games' | translate | uppercase}}</h1>
            <h1 class="section-title-second float-right" [routerLink]="['/slots-game', firstHotGameProvider]" [queryParams]="{ HG: true }">{{ 'More Games' | translate | uppercase }} ></h1>
            <div id="promotionSlider">
                <div class="swiper" appSwiper [config]="hotGameConfig">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide portfolio-item game-container" id="portfolio" *ngFor="let list of gameStack">
                            <div class="grid-inner">
                                <div class="portfolio-image">
                                    <img [src]="list.local_image_path ? list.local_image_path : list.image_path" [alt]="list.name" (error)="onImgSrcError($event)"
                                    [ngClass]="{'disabled': (isLoggedIn$ | async) && (list.maintenance === 1 || list.available === 0)}"/>

                                    <div class="bg-overlay" *ngIf="(isLoggedIn$ | async) ? (list.maintenance === 0 && list.available === 1) : true; else dontShowPlay">
                                        <div class="bg-overlay-content dark" data-hover-animate="fadeIn">
                                        <div class="bg-overlay play-hover-box" (click)="onCheckBonusForHotGame(list, list.code, list.TYPE, false)">
                                            <div class="play-hover">
                                                <div [innerHTML]="svg.playIcon | safeHtml" class="play-icon"></div>
                                                <p>PLAY</p>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <ng-template #dontShowPlay>
                                    <div class="bg-overlay" (mouseenter)="onCheckHover(list)">
                                        <div class="bg-overlay-content dark" data-hover-animate="fadeIn">
                                        </div>
                                    </div>
                                    </ng-template>

                                    <div class="show-notice-2" *ngIf="(isLoggedIn$ | async) && list.showMaintenance">
                                        <span [innerHTML]="svg.maintenanceIcon | safeHtml" class="provider-icon"></span>
                                        <div class="maintenance-text">{{ 'Under\n Maintenance' | translate }}</div>
                                    </div>

                                    <div class="show-notice-2" *ngIf="(isLoggedIn$ | async) && list.showNoPromo">
                                        <span [innerHTML]="svg.noPromoIcon | safeHtml" class="provider-icon"></span>
                                        <div class="promotion-text">{{ 'This promotion can\'t be used on this game.' | translate }}</div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-12 text-center game-name">
                                        <p class="hot-game-title">{{ list.name | titlecase }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Skeleton Loading -->
        <ng-template #skeletonHotGames>
            <ng-container *ngIf="isSkeletonHotGames">
                <div class="row skeleton-container">
                    <div class="portfolio-item game-container col-xl-3 col-md-4 col-sm-6 col-12" *ngFor="let item of [].constructor(4); let i = index">
                        <div class="grid-inner skeleton-grid-inner">
                            <div class="portfolio-image">
                                <div class="skeleton skeleton-game-image"></div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center game-name">
                                    <p class="skeleton skeleton-text skeleton-game-provider-text w-50"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-template>
        
        
    </div>

    <!-- Promotion -->
    <div class="container m-b-60">
        <ng-container *ngIf="promotions.length > 0 && !isSkeletonPromotions; else skeletonPromotions">
            <h1 class="section-title float-left">{{'Promotion' | translate | uppercase}}</h1>
            <h1 class="section-title-second float-right" routerLink="/promotion">{{ 'Find Out More' | translate | uppercase }} ></h1>
            <div id="promotionSlider">
                <div class="swiper" appSwiper [config]="promotionConfig">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" *ngFor="let item of promotions">
                            <img [src]="item.image" />
                            <div class="promotion-card-bg p-15 limited_height">
                                <h3>{{ item.title }}</h3>
                                <a routerLink="/promotion">{{ 'Find Out More' | translate | uppercase }} ></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Skeleton Loading -->
        <ng-template #skeletonPromotions>
            <ng-container *ngIf="isSkeletonPromotions">
                <div id="promotionSlider">
                    <div class="swiper-wrapper skeleton-swiper-wrapper">
                        <div class="swiper-slide skeleton-swiper-slide" *ngFor="let item of [].constructor(4); let i = index">
                            <div class="promotion-card-bg p-0 border-5" style="height: 350px;">
                                <p class="skeleton skeleton-promotion-img rounded-top m-0 border-top-5"></p>
                                <div class="p-15">
                                    <h3 class="skeleton skeleton-text w-50"></h3>
                                    <ng-container *ngFor="let item of [].constructor(2); let i = index">
                                        <p class="m-b-0 font-size-4 font-color-6 font-weight-400 skeleton skeleton-text"></p>
                                    </ng-container>
                                    <p class="skeleton skeleton-text w-50 mt-1 float-right"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-template>
    </div>

    <!-- USP Section -->
    <ng-container *ngIf="usps.length > 0 && !isSkeletonUsp; else skeletonUspLength">
        <div class="container m-b-50" >
            <div class="row justify-content-center">
                <div *ngIf="uspMainContent" class="col-12">
                    <h1 class="section-title">{{ uspMainContent.content | uppercase }}</h1>
                </div>
                <ng-container>
                    <div class="col-4" *ngFor="let usp of usps">
                        <div class="why-us-box">
                            <span [innerHTML]="usp.svg_icon | safeHtml"></span>
                            <h3>{{ usp.title | uppercase }}</h3>
                            <p>{{ usp.content }}</p>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>

    <!-- Skeleton Loading -->
    <ng-template #skeletonUspLength>
        <ng-container *ngIf="isSkeletonUsp">
            <div class="container m-b-50">
                <div class="row">
                    <div class="col-12">
                        <h1 class="section-title skeleton skeleton-category-title"></h1>
                    </div>
                    <ng-container *ngFor="let item of [].constructor(3); let i = index">
                        <div class="col-4">
                            <div class="why-us-box">
                                <span class='skeleton'></span>
                                <h3 class="skeleton skeleton-title"></h3>
                                <ng-container *ngFor="let item of [].constructor(3); let i = index">
                                    <p class="skeleton skeleton-text"></p>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </ng-template>

    <ng-container *ngIf="uspNumberContents.length > 0 && !isSkeletonUsp; else skeletonUspNumberContents">
        <div class="m-b-50 usp-banner">
            <div class="container m-t-25">
                <div class="row vertical-center">
                    <div class="col-7">
                        <div class="row vertical-center margin-content">
                            <div class="col-5">
                                <p class="usp-title-1">{{ 'NO.1' | uppercase }}</p>
                            </div>
                            <div class="col-7 p-l-0">
                                <p class="usp-title-2" [innerHtml]="'Online Casino<br>In [country_name]' | translate : { country_name : countryName }"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-7">
                    <div class="row m-l-0 m-r-0">
                        <ng-container *ngFor="let uspNumberContent of uspNumberContents">
                            <div class="col-4">
                                <h5 class="usp-title-3">{{ uspNumberContent.title | uppercase }}</h5>
                                <p class="usp-title-4">{{ uspNumberContent.content  | uppercase }}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Skeleton Loading -->
    <ng-template #skeletonUspNumberContents>
        <ng-container *ngIf="isSkeletonUsp">
            <div class="m-b-50 usp-banner">
                <div class="container m-t-25">
                    <div class="row vertical-center">
                        <div class="col-7">
                            <div class="row vertical-center margin-content">
                                <div class="col-5">
                                    <ng-container *ngFor="let item of [].constructor(6); let i = index">
                                        <p class="usp-title-1 skeleton skeleton-text"></p>
                                    </ng-container>
                                </div>
                                <div class="col-7 p-l-0">
                                    <ng-container *ngFor="let item of [].constructor(6); let i = index">
                                        <p class="usp-title-1 skeleton skeleton-text"></p>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-7 p-0">
                        <div class="row m-l-0 m-r-0">
                            <ng-container *ngFor="let item of [].constructor(3); let i = index">
                                <div class="col-4 pr-10 pl-0 border-0">
                                    <h5 class="usp-title-3 skeleton skeleton-text w-50"></h5>
                                    <ng-container *ngFor="let item of [].constructor(2); let i = index">
                                        <p class="usp-title-4 skeleton skeleton-text"></p>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-template>

    <!-- FAQ -->
    <ng-container *ngIf="faqsLength > 0 && !isSkeletonFaqs && faqdata > 0; else skeletonfaqsLength">
        <div class="container m-b-100">
            <h1 class="section-title">{{'Frequently Asked Questions' | translate | uppercase}}</h1>
            <div [ngClass]="{'m-b-30': faqsLength !== (i+1)}" *ngFor="let faq of faqs | slice:0:1; let i = index">
                <mat-accordion class="faq-section" *ngIf="faq.contents !== undefined">
                    <ng-container *ngFor="let item of faq.contents">
                        <mat-expansion-panel class="m-b-15" (afterExpand)="scroll(item.id)" hideToggle>
                            <mat-expansion-panel-header>
                                <mat-panel-title [id]="item.id">
                                    <div [innerHTML]="item.question"></div>
                                    <i class="icon-chevron-down dropdown-arrow-img"></i>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div [innerHTML]="sanitize(item.answer)" class="faq-body"></div>
                        </mat-expansion-panel>
                    </ng-container>
                </mat-accordion>
            </div>
        </div>
    </ng-container>

    <!-- Skeleton Loading -->
    <ng-template #skeletonfaqsLength>
        <ng-container *ngIf="isSkeletonFaqs">
            <div class="container m-b-100">
                <h1 class="section-title skeleton skeleton-category-title"></h1>
                <div *ngFor="let item of [].constructor(5) | slice:0:1; let i = index">
                    <mat-accordion class="faq-section">
                        <ng-container *ngFor="let item of [].constructor(5); let i = index">
                            <mat-expansion-panel class="m-b-15 border-0">
                                <mat-expansion-panel-header class="skeleton">
                                </mat-expansion-panel-header>
                            </mat-expansion-panel>
                        </ng-container>
                    </mat-accordion>
                </div>
            </div>
        </ng-container>
    </ng-template>

    <!-- App Download Area (qp8) -->
    <div class="app-download-section-bg" *ngIf="sitePrefix == 'la'">
        <div class="container">
            <div class="app-download-section row m-l-0 m-r-0">
                <div class="col-md-6 app-download-section-img d-flex align-items-center justify-content-end px-5">
                    <img src="/assets/images/app-download/side-banner.png">
                </div>
                <div class="col-md-6 p-l-40" style="margin: auto;">
                    <div class="app-download-text">
                        <p>{{ 'App Download' | translate }}</p>
                        <div class="la-icon">
                            <img src="/assets/images/app-download/la-icon.png">
                        </div>
                    </div>
                    <div class="app-download-section-title">
                        <h5>{{ 'New Gaming Era Begins Here!\nDownload Our App Now' | translate }}</h5>
                    </div>
                    <div class="app-download-section-description">
                        {{ 'Best app that will help you to earn money by playing an intellectual game. An all-in-one app for you with endless rewards, promotion and exclusive betting experiences. Welcome to a world of infinite possibilities, all within your smartphone!' | translate }}
                        <p class="mt-20">{{ 'Download and sign up today for more exciting rewards, promotions and prizes!' | translate }}</p>
                        <p class="mt-20 text-warning-01">{{ 'Click Here or Scan The QR Code To Download' | translate }}</p>
                    </div>
                    <div class="app-download-section-button">
                        <div class="row">
                            <div class="col-md-4" *ngFor="let platform of ['android', 'ios']; let i = index">
                                <img class="download-image" [src]="'/assets/images/app-download/' + platform + '/download.png'" (click)="onDownloadApp(platform)">
                                <div class="qr-image">
                                    <img [src]="'/assets/images/app-download/' + platform + '/qr-code.png'">
                                </div>
                                <span class="instruction-text" (click)="onGetInstruction(platform)"> <i class="fas fa-info-circle"></i> {{ 'Instructions' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>